module.exports = __webpack_public_path__ + "static/media/nft.b798cee3.png";